<template>
  <div class="zj-mainpage-main">
    <audio controls="controls" hidden muted src="static/sounds/钉钉提示音.mp3" ref="audio"></audio>
    <el-container class="zj-mainpage-ct">
      <el-header class="zj-mainpage-topheader">
        <div class="zj-mainpage-topheader-left">
          <img @click="refreshPage" style="cursor: pointer;" :src="'assets/logo/' + $SYSTEM_ICON" height="35" />
          <span @click="refreshPage" class="zj-mainpage-sysname">{{ $SYSTEM_NAME }}</span>
        </div>
        <div class="zj-mainpage-breadcrumb-ct" v-if="breadCrumbList.breadCrumbList.length > 1">
          <nav-breadcrumb />
        </div>
        <ul class="zj-mainpage-topheader-right">
          <li data-step="1" data-intro="查看消息">
            <el-tooltip effect="light" content="查看消息" placement="bottom-start">
              <i class="el-icon-message-solid" style="position:relative;" @click="showMsg = true">
                <span v-show="msgList.length > 0" class="zj-message-unread"></span>
              </i>
            </el-tooltip>
          </li>
          <li>
            <el-dropdown trigger="hover" szie="medium">
              <span class="zj-mainpage-dropdown-span">
                <i class="el-icon-question" @click="startGuide"></i>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="min-width: 150px;">
                <el-dropdown-item divided @click.native="downLoadOneDoc()">下载操作手册</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li data-step="2" data-intro="切换公司">
            <el-dropdown trigger="hover" szie="medium">
              <span class="zj-mainpage-dropdown-span">
                <i class="el-icon-menu"></i>
                <span>{{ accountInfo.company.c_name }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="min-width: 150px;" hide-timeout="500">
                <el-dropdown-item @click.native="selectCompany(item)" v-for="(item, index) in accountInfo.companies"
                  :key="index" icon="el-icon-menu">
                  {{ item.c_name }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li data-step="3" data-intro="个人中心">

            <el-dropdown trigger="hover" szie="medium">
              <span class="zj-mainpage-dropdown-span">
                <i class="el-icon-user"></i>

                <span>{{ accountInfo.emp_name }}</span>
                <el-badge :value="needBindCount" class="item-badge" v-if="needBindCount > 0">

                </el-badge>
                <i class="el-icon-arrow-down el-icon--right"></i>

              </span>

              <el-dropdown-menu slot="dropdown" style="min-width: 150px;">
                <el-dropdown-item @click.native="changePasswordVisible = true">修改密码</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="changePasswordVisible = true">修改单位</el-dropdown-item> -->
                <el-dropdown-item divided @click.native="bindEmail">绑定邮箱
                  <el-badge class="item" :value="1" size="mini" v-if="!accountInfo.email" />
                </el-dropdown-item>
                <el-dropdown-item divided @click.native="bindWX">绑定微信
                  <el-badge class="item" :value="1" v-if="!accountInfo.wx_unionid" />
                </el-dropdown-item>
                <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </li>
          <li>
            <screen-full />
          </li>
        </ul>
      </el-header>
      <el-container>
        <el-aside :width="isCollapse ? '64px' : '200px'" class="zj-mainpage-aside-ct" data-step="4" data-intro="菜单导航">
          <nav-menu-tree-collapse :isCollapse.sync="isCollapse" />
          <!-- 后台 -->
          <el-menu style="width:100%;background-color:#ddecfd;" collapse v-if="isAdmin || isDeveloper">
            <el-submenu index="otherFlatForm">
              <template slot="title">
                <i class="el-icon-more"></i>
              </template>
              <el-menu-item-group>
                <el-menu-item @click="openBsm" v-if="isAdmin || isDeveloper">
                  <i class="el-icon-s-management"></i>
                  <span slot="title">后台管理</span>
                </el-menu-item>
                <el-menu-item @click="openDev" v-if="isDeveloper">
                  <i class="el-icon-monitor"></i>
                  <span slot="title">开发者后台</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-aside>
        <el-container>
          <el-header class="zj-mainpage-navheader">
            <nav-bar />
          </el-header>
          <el-main class="zj-mainpage-childpage-ct">
            <keep-alive>
              <router-view class="zj-mainpage-childpage-common" ref="routerPage"
                v-if="$route.meta.keepAlive === true" />
            </keep-alive>
            <router-view class="zj-mainpage-childpage-common" ref="routerPage" v-if="$route.meta.keepAlive !== true" />
            <!-- 主页 -->
            <home-page v-if="activeTabName == 'main'" />
          </el-main>
        </el-container>
      </el-container>
    </el-container>

    <el-dialog title="消息列表" close-on-click-modal :visible.sync="showMsg" width="800px" top="5vh">
      <msg></msg>
    </el-dialog>

    <!-- 修改密码 -->
    <changePwd :visible.sync="changePasswordVisible" />
    <!-- 二维码绑定 -->
    <el-dialog v-dialogDrag width="450px" title="二维码绑定" :visible.sync="qrVisible" :close-on-click-modal="false"
      append-to-body>
      <template>
        <!-- <img class="half-png" src="assets/img/web-half.png" @click="tabClick('password')" /> -->
        <div style="height:400px">
          <div class="image-div">
            <img class="center-png" src="assets/logo/logo_circle.png" />
          </div>
          <div class="qrcode-ct">
            <div @click="getQrCodeByBind">
              <vue-qr :text="qr_src" binarize :size="200" :margin="10" style="border: 1px solid #eee"></vue-qr>
              <!-- <vue-qr :text="qr_src" :size="200" :margin="10" style="border: 1px solid #eee"></vue-qr> -->
            </div>
            <div class="qr-tip">{{ qr_tip }}</div>
          </div>
        </div>

      </template>
    </el-dialog>
    <!-- 邮箱绑定 -->
    <el-dialog v-dialogDrag width="450px" title="邮箱 绑定" :visible.sync="emailVisible" :close-on-click-modal="false"
      append-to-body>
      <template>

        <div class="image-div">
          <img class="center-png" src="assets/logo/logo_circle.png" />
        </div>
        <div class="input-area">
          <div class="input-item">
            <el-input v-model="emailNumber" placeholder="请输入注册邮箱">

            </el-input>
          </div>
          <div class="input-item" style="display:flex;flex-direction:row">
            <div>
              <el-input v-model="checkPassword" placeholder="验证码" style="width:100px">
              </el-input>
            </div>
            <div style="line-height:40px;margin-left:10px">
              <el-button v-show="sendAuthCode" @click="getAuthCode" style="margin-left:30px">
                获取验证码
              </el-button>
              <el-button v-show="!sendAuthCode" :disabled="sendAuthCode" @click="getAuthCode">
                {{ auth_time }}秒之后重新发送验证码
              </el-button>

            </div>
          </div>
          <!-- <div>
            <span class="remember-ct" @click="bindWeChat = !bindWeChat">
              <input class="remember-check" type="checkbox" value v-model="bindWeChat" />
              <span class="remember-text">是否绑定微信</span>
            </span>

          </div> -->
          <div class="login-button-ct">
            <el-button class="login-button" type="primary" @click="confirmEmail()">{{ bindText }}</el-button>
            <el-button class="login-button" @click="emailVisible = !emailVisible"
              style="margin-left:20px">取消</el-button>
          </div>

        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import NavMenuTreeCollapse from '@/common/components/nav-menu-tree-collapse';
import NavBreadcrumb from '@/common/components/nav-breadcrumb';
import NavBar from "@/common/components/nav-bar";
import changePwd from '@/common/components/changePwd';
import changeCompany from '@/common/components/changeCompany';
import ScreenFull from '@/common/components/screen-full';
import msg from "@/pub/components/sys/msg";
import HomePage from './home-page/home-page';
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Cookies from "js-cookie";
import Axios from 'axios';
import vueQr from 'vue-qr'


export default {

  name: "Main",
  components: {
    vueQr,
    NavMenuTreeCollapse,
    NavBreadcrumb,
    NavBar,
    changePwd,
    changeCompany,
    ScreenFull,
    msg,
    HomePage,
  },
  data() {
    return {

      sendAuthCode: true,
      auth_time: '',
      vc_id: '',
      checkPassword: '',
      emailNumber: '',
      emailVisible: false,
      ischeck: false,
      timer: null,
      openid: '',
      qr_code: "",
      qr_over_due: true,
      qr_src: '',
      qr_tip: '',
      qrVisible: false,
      projectList: [],
      msgListTemp: [],
      isCollapse: true,
      changePasswordVisible: false,
      changeCompanyVisible: false,
      showMsg: false,
      bindText: '确认',
    };
  },
  computed: {
    ...mapState("navTabs", ["breadCrumbList"]),
    ...mapState(["msgList", "accountInfo"]),
    ...mapGetters(["isDeveloper", "isAdmin"]),
    activeTabName() {
      return this.$store.state.navTabs.activeTabName;
    },
    needBindCount() {
      let a = this.accountInfo.wx_unionid ? 0 : 1;
      let b = this.accountInfo.email ? 0 : 1;
      return a + b;

    }
  },
  methods: {

    confirmEmail() {
      if (this.emailNumber == "") {
        this.$message({
          message: "邮箱不能为空!",
          type: "warning",
          duration: 1000
        });
        return;
      }
      if (this.checkPassword.length < 6) {
        this.$message({
          message: "请输入6位验证码!",
          type: "warning",
          duration: 1000
        });
        return;
      }
      this.bindText = "正在验证..."

      this.z_post('access/api/home/CheckMailVc', {}, {
        params: {
          vc_id: this.vc_id,
          email: this.emailNumber,
          vc_value: this.checkPassword,
        }
      }).then(res => {
        this.bindEmailById();

        // this.tabClick('login');
      }).catch(err => {
        this.$message({
          message: "验证失败!" + err.msg,
          type: "warning",
          duration: 1000
        });
        this.findText = "重新确认"
      })


    },
    bindEmailById() {

      this.z_put('api/userInfoForBind/bindEmail', {}, {
        params: {

          email: this.emailNumber,

        }
      }).then(res => {
        this.$message({
          message: "绑定成功!",
          type: "success",
          duration: 1000
        });

        this.accountInfo.email = this.emailNumber;

        this.emailVisible = false;
        // this.tabClick('login');
      }).catch(err => {
        this.$message({
          message: "验证失败!" + err.msg,
          type: "warning",
          duration: 1000
        });
        this.bindText = "重新确认"
      })

    },
    chkEmail(strEmail) {
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(strEmail)) {
        return false;
      }
      else {
        return true;
      }
    },
    getAuthCode() {


      if (!this.chkEmail(this.emailNumber)) {
        this.$message({
          message: "邮箱格式有误，请重新填写!",
          type: "error",
          duration: 1000
        });
        return;
      }

      this.z_post('access/api/userinfo/SendVcToMailForBind', {}, {
        params: {
          email: this.emailNumber,
          vc_type: 'bind'
        }
      }).then(res => {
        this.vc_id = res.data;
        this.$message({
          message: "验证码发送成功,请检查你的邮箱文件!",
          type: "success",
          duration: 1000
        });
        this.startTimer();

      }).catch(err => {
        this.$message({
          message: "验证码发送失败," + err.msg,
          type: "error",
          duration: 1000
        });




      })





    },
    startTimer() {
      this.sendAuthCode = false;
      //设置倒计时秒
      this.auth_time = 60;
      var auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
    },
    bindEmail() {
      if (this.accountInfo.email) {
        this.$message({
          message: "该账户已绑定邮箱!",
          type: "warning",
          duration: 1000
        });
        return;

      }
      this.bindText = "确认";
      this.emailVisible = true;


    },

    //微信绑定
    bindWX() {
      this.getBrowserClientId()
      console.log(this.getBrowserClientId());
      console.log(window.location.origin);

      if (this.accountInfo.wx_unionid) {
        this.$message({
          message: "该账户已绑定微信!",
          type: "warning",
          duration: 1000
        });
        return;
      }
      this.qrVisible = true;
      this.qr_over_due = true;
      this.getQrCodeByBind();
    },
    //二维码生成 
    getQrCodeByBind() {

      if (this.qr_over_due) {
        if (this.timer != null) {
          clearInterval(this.timer);
        }
        this.z_post("api/scan/generateCode", {

        }, {
          params: {
            client_id: this.getBrowserClientId(),
            type: "bind",
            origin: window.location.origin
          }
        }).then(res => {
          console.log("438");

          this.qr_src = res.data.url;

          //this.qr_src = "data:image/png;base64," + res.data.url;//网页端调试
          this.qr_code = res.data.code;
          this.qr_over_due = false;
          this.qr_tip = "请用微信扫码绑定";
          //这里应该由确认登录后才调用

          this.timer = setInterval(() => {
            if (this.ischeck == false) {

              this.ischeck = true;
              this.z_get("api/scan/CheckQrStatus", {
                code: this.qr_code,
                scanType: 'bind'
              }).then(r => {
                console.log(457);
                console.log("458res", res);

                this.ischeck = false;
                if (r.data.status == 10) {
                  this.qr_tip = "扫描成功，等待确认";
                  this.qr_over_due = true;
                } else if (r.data.status == 20) {
                  this.qr_tip = "绑定成功";
                  this.postBindWX(r.data.wx_openid, r.data.wx_unionid);
                  clearInterval(this.timer);
                  // window.localStorage.setItem("AccountInfo", JSON.stringify({
                  //   token: r.data.token,
                  //   company: { c_id: r.data.c_id }
                  // }));
                  // window.location.href = window.location.origin + `?t=${new Date().getTime().toString(16)}`;


                } else if (r.data.status == -10) {
                  clearInterval(this.timer);
                  this.qr_over_due = true;
                  this.qr_tip = "二维码已过期，点击重新获取";
                }
              }).catch(e => {
                this.ischeck = false;
              });
            }
          }, 1500);
        }).catch(err => {
          this.qr_tip = "获取二维码失败：" + err.msg;
        });
      }
    },
    postBindWX(wx_openid, wx_unionid) {
      console.log("111")
      let row = [{ appid: 'wx5e36e6df39f10d11', openid: wx_openid }];
      console.log("wx_openid，wx_unionid", wx_openid, wx_unionid)
      this.z_post("api/home/bindWX", {}, {
        params: {
          emp_id: this.accountInfo.emp_id,
          wx_openid: JSON.stringify(row),
          wx_unionid: wx_unionid
        }
      }).then(res => {

        this.$message({
          message: "成功!",
          type: "success",
          duration: 1000
        });
        this.accountInfo.wx_unionid = this.wx_unionid;
      }).catch(res => {

        this.$alert("失败!" + res.msg, "提示", {
          confirmButtonText: "确定",
          type: "error"
        });
      });

    },
    ...mapMutations(["addMsg", "setCompany"]),
    openBsm() {
      window.open(`${window.location.origin}/bsm.html?t=${new Date().getTime().toString(16)}`, "_blank");
    },
    openDev() {
      window.open(`${window.location.origin}/dev.html?t=${new Date().getTime().toString(16)}`, "_blank");
    },
    refreshPage() {
      this.$router.push({
        name: "main"
      });
    },
    //退出登录
    logout() {
      this.z_post("access/api/home/logout").then(res => {
        window.location.href = `${window.location.origin}/login.html?t=${new Date().getTime().toString(16)}`;
      }).catch(err => {
        console.log(err);
        window.location.href = `${window.location.origin}/login.html?t=${new Date().getTime().toString(16)}`;
      });
    },
    selectCompany(item) {
      if (this.accountInfo.company.c_id != item.c_id) {
        this.setCompany(item);
        window.location.reload();
      }
    },
    startGuide() {
      this.introJs.start();
    },
    //下载操作手册
    downLoadOneDoc() {
      //var path = "System\\Help\\WEB\\知匠项目管控系统-操作手册.pdf";
      //this.downLoadFile(this.Global.baseUrl + `api/DownLoadAPI?path=${path}`);
    },
    getComponent(path) {
      return resolve => {
        require.ensure([], require => {
          try {
            resolve(require("@/zxx/components/" + path));
          } catch (error) {
            //从公共模块中查找
            resolve(require("@/pub/components/" + path));
          }
        });
      };
    },
    getRouter() {
      this.$store.commit("navTabs/emptyMenuTreeList");
      this.z_get("access/api/home/userMenuTree", {
        module_code: this.$SYSTEM_CODE
      }, {
        loading: true
      }).then(res => {
        if (res.data.length > 0) {
          this.$store.commit("navTabs/setMenuTreeList", res.data);

          var mainRouter = this.$router.options.routes.filter(item => item.name == "main");
          if (!mainRouter.length) return;
          var main = this.deepClone(mainRouter[0]);
          main.children = [];
          //加载路由
          var treeList = this.$store.state.navTabs.menuTreeListFlatten;
          for (var i = 0; i < treeList.length; i++) {
            var oneMenu = treeList[i];
            if (oneMenu.menu_link) {
              var menu_link = oneMenu.menu_link;
              main.children.push({
                path: "/" + menu_link,
                name: menu_link,
                component: this.getComponent(menu_link),
                meta: {
                  keepAlive: oneMenu.menu_is_keep === true
                }
              });
            }
          }
          this.$router.addRoute(main);
          //有路由的刷新，看有没有权限
          if (this.$route.redirectedFrom && this.$route.redirectedFrom != '/') {
            var redirectedFrom = this.$route.redirectedFrom;
            var hasAu = treeList.filter(item => '/' + item.menu_link == redirectedFrom);
            if (hasAu.length > 0) {
              var menu_link = hasAu[0].menu_link;
              this.$router.push({
                name: menu_link
              })
            }
          }
        } else {
          this.$alert("没有菜单权限，请联系管理员配置", "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
          return;
        }
      })
    }
  },
  created() {
    this.getRouter(); //加载路由
  }
}
</script>

<style scoped>
.login-button-ct {
  margin-top: 50px;
  text-align: center;
  padding: 0px 0px;
}

.login-button {
  width: 30%;
  height: 40px;
  font-size: 20px;
  padding: 0;
}

.input-area {
  padding: 20px 50px 0 50px;
}

.input-item {
  margin-top: 20px;
}

.item-badge {
  margin-top: 0px;
}

.item {
  margin-top: 10px;
}

.image-div {
  margin-top: 20px;
  text-align: center;
}

.center-png {
  margin: auto;
  top: 1;
  cursor: pointer;
  width: 55px;
}

.qrcode-ct {
  height: 200px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qr-tip {
  font-size: 15px;
  margin-top: 5px;
}
</style>
